import { useQuery } from "react-query";
import { useHttpClient } from "../../../../shared/http/HttpClientProvider";
import { ConnectorTypes } from "../../../../shared/types/common";
import { QueryOptions, QueryResult } from "../../../../shared/types/query";
import { useZoomMetadataParser, ZoomMetadata } from "../types/zoom-metadata";

export const KEY_GET_ZOOM_METADATA = 'zoomSettings/getZoomMetadata';

export function useGetZoomMetadata(options?: QueryOptions<ZoomMetadata>): QueryResult<ZoomMetadata> {
  const http = useHttpClient();
  const zoomMetadataParser = useZoomMetadataParser();

  return useQuery<ZoomMetadata>({
    ...options,
    queryKey: [KEY_GET_ZOOM_METADATA, http],
    queryFn: async () => {
      return http.request({
        method: 'get',
        url: `ServerConfiguration/${ConnectorTypes.Zoom}/metadata`,
      }).then(result => zoomMetadataParser.fromJson(result.data))
    },
  })
}
